import * as React from 'react';
import * as Redux from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { Grid, Stack, Tooltip, Typography } from '@mui/material';
import {
  deleteModulosAction,
  allModulosAction,
  setActivoModulosAction,
} from '../ModulosAction';
import styled from 'styled-components';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { LoadingWidget } from '../../../../widgets';
import { Chip } from '@mui/material';
import ActionsListWidget from '../../../../widgets/ActionsList';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import { useNotification } from '../../../../helpers/Notification';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoModulos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const modulosStore = Redux.useSelector((state) => state.modulos);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      if (modulosStore.all && modulosStore.all.length === 0) {
        await allModulosAction(dispatch, null);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = modulosStore.all.find((el) => el.id === id);
    await setActivoModulosAction(dispatch, data);
    setOpenModalForm(true);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteModulosAction(
      { dispatch, notify },
      modulosStore.activo.id,
      modulosStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.route.name,
      label: CONST.route.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.alias.name,
      label: CONST.alias.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.icon.name,
      label: CONST.icon.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    // {
    //   name: CONST.imagen.name,
    //   label: CONST.imagen.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //   },
    // },

    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value.nombre}
                size="small"
                color={value.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={() => {
                  const data = modulosStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  setActivoModulosAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  const isEntidades = modulosStore.activo?.totalEntidades > 0;

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={modulosStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={'Listado'}
          data={modulosStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {modulosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
          isText={!isEntidades}
          isConfirmBottom={!isEntidades}
        >
          {isEntidades ? (
            <Typography variant="body1">
              No puedes eliminar esta carrera porque tiene entidades relacionada
            </Typography>
          ) : (
            <Typography variant="h6">{modulosStore.activo.nombre}</Typography>
          )}
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoModulos;
